<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
import './App.scss';
import {mapActions, mapState, mapMutations} from 'vuex';
import {updateReturnBtn} from '@/pages/pano-game/constant/JumpFunc';

export default {
    name: 'app',
    computed: {
        ...mapState(['urlParams'])
    },
    mounted() {
        // 设置端内透明壳返回按钮
        updateReturnBtn();
        // 拿url上所有参数
        this.getUrlParams().then(() => {
            if (this.urlParams.level) {
                this.setLevel(this.urlParams.level);
            }
            // 路由重定向
            this.pageRedirect();
        });
    },
    methods: {
        ...mapMutations('pano', [
            'setLevel'
        ]),
        ...mapActions([
            'getUrlParams'
        ]),
        /**
         * 页面重定向
         * 通过url中的pageType参数来重新定向页面
         */
        pageRedirect() {
            if (this.urlParams.pageType === 'kingRoad') {
                this.$router.push({
                    path: '/kingRoad'
                });
            } else if (this.urlParams.pageType === 'escape') {
                this.$router.push({
                    path: '/escape'
                });
            }
        }
    }
};
</script>
